var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "aimo-panel" }, [
    _c("div", { staticClass: "aimo-panel-title" }, [
      _c("i", { staticClass: "fas fa-microchip" }),
      _vm._v(" " + _vm._s(_vm.strings.modelPanelTitle)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "model-info" }, [
      _c("div", { staticClass: "model-row" }, [
        _c("span", { staticClass: "model-label" }, [
          _vm._v(_vm._s(_vm.strings.provider)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "model-value is-provider" }, [
          _vm._v("Tracking Cloud® — Bluugo Oy"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "model-row" }, [
        _c("span", { staticClass: "model-label" }, [
          _vm._v(_vm._s(_vm.strings.modelPanelTitle)),
        ]),
        _vm._v(" "),
        _vm.models.length
          ? _c("div", { staticClass: "select is-small is-fullwidth" }, [
              _c(
                "select",
                {
                  attrs: {
                    disabled: _vm.disabled,
                    title: _vm.strings.chooseModel,
                  },
                  on: { change: _vm.onChange },
                },
                _vm._l(_vm.models, function (m) {
                  return _c(
                    "option",
                    {
                      key: m.id,
                      domProps: {
                        value: m.id,
                        selected: m.id === _vm.selectedModelId,
                      },
                    },
                    [_vm._v(_vm._s(m.name))]
                  )
                }),
                0
              ),
            ])
          : _c("span", { staticClass: "model-value" }, [
              _vm._v(_vm._s(_vm.strings.noModels)),
            ]),
      ]),
      _vm._v(" "),
      _vm.aiModelsUrl
        ? _c("div", { staticClass: "model-row" }, [
            _c("a", { attrs: { href: _vm.aiModelsUrl } }, [
              _c("i", { staticClass: "fas fa-cog" }),
              _vm._v(" " + _vm._s(_vm.strings.aiModels)),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }